import axios from '../../../../utills/axiosConfig';

export const fetchMetalTypes = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/metal-types', { params });
  return res.data;
};

export const addMetalType = async (metalType) => {
  try {
    const res = await axios.post('/metal-types', metalType);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateMetalType = async (id, metalType) => {
  console.log('API call - Updating metal type:', id, metalType);
  const res = await axios.put(`/metal-types/${id}`, metalType);
  console.log('API response:', res.data);
  return res.data;
};

export const deleteMetalType = async (id) => {
  const res = await axios.delete(`/metal-types/${id}`);
  return res.data;
};

export const importMetalTypeCSV = async (formData) => {
  const { data } = await axios.post('/metal-types/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 